var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yzxbuy-entrance"},[_c('top-title'),_c('price',{attrs:{"priceList":_vm.priceList}}),_c('brightPoints'),_c('comparison'),_c('trial')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }